var render, staticRenderFns
import script from "./CopyIdButton.vue?vue&type=script&lang=js&"
export * from "./CopyIdButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a089d594')) {
      api.createRecord('a089d594', component.options)
    } else {
      api.reload('a089d594', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Elements/CopyIdButton.vue"
export default component.exports